import { render, staticRenderFns } from "./TagRounded.vue?vue&type=template&id=31550e10&"
import script from "./TagRounded.vue?vue&type=script&lang=js&"
export * from "./TagRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports